import { useNavigate } from "react-router-dom";
import { DefaultButton } from "../button/defaultButton/DefaultButton";
import styles from "./ErrorPage.module.scss";
import {
  getDefaultRoutePath,
} from "../../infrastructure/routes/routePaths";
import { useAppContext } from "../../../AppContext";

export const ServerErrorPage = () => {
  const navigate = useNavigate();
  const { currentUser } = useAppContext();

  const backToPlanner = () => {
    navigate(getDefaultRoutePath(currentUser));
  };

  return (
    <div className={styles.root}>
      <p>Нещо се обърка. Моля, опитайте по-късно.</p>
      <DefaultButton
        className={styles.root_button}
        label={"Обратно към Календара"}
        onClick={backToPlanner}
      />
    </div>
  );
};
